import React, { forwardRef, ReactNode } from 'react';
import Typo from '../Typography/Typo';

type TTerritorySectionTitleProps = {
  children: ReactNode;
};

export const TerritorySectionTitle = forwardRef<HTMLDivElement, TTerritorySectionTitleProps>(({ children }, ref) => (
  <div className="relative">
    <div ref={ref} className="absolute -top-[100px]" />
    <Typo variant="p1" className="mb-5 !text-[22px] !leading-9 font-semibold text-t2-neutral-grey07">
      {children}
    </Typo>
  </div>
));
